import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    useRefresh,
    useNotify,
    fetchStart,
    fetchEnd
} from 'react-admin';
import { Remove } from '@material-ui/icons';
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import ButtonMui from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

const DeactivateDivisionButton = (prop) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickDialog = () => {
        handleClick();
        handleClose();
    }

    const [loading, setLoading] = useState(false);
    const handleClick = () => {
        setLoading(true);
        dispatch(fetchStart());

        fetch(`${process.env.REACT_APP_API_ENTRYPOINT}/${prop.resource}/${prop.record.id}/deactivate`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'X-Session': localStorage.getItem('session')
                },
                method: 'GET',
            })
            .then((response) => {
                refresh();
                return response.json();
            })
            .then((result) => {
                if (result.error?.message) {
                    notify('Помилка: ' + result.error.message, 'error');
                }
            })
            .catch((e) => {
                notify('Помилка: заклад не деактивовано', 'warning');
            })
            .finally(() => {
                setLoading(false);
                dispatch(fetchEnd()); // stop the global loading indicator
            });
    };

    return (
        <div>
        <Button
            label="Деактивувати"
            disabled={false}
            onClick={handleClickOpen}
            color="secondary"
        >
            <Remove />
        </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Ви впевнені що хочете деактивувати аптеку?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonMui onClick={handleClose} color="primary">
                        Відхилити
                    </ButtonMui>
                    <ButtonMui onClick={handleClickDialog} color="primary" autoFocus>
                        Погоджуюсь
                    </ButtonMui>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DeactivateDivisionButton;
